import * as apiImportCommentsFromTemplate from "@/api/vp/activationPlan/importCommentsFromTemplate";
import * as apiImportEventsFromTemplate from "@/api/vp/activationPlan/importEventsFromTemplate";
import * as apiImportCampaignsFromTemplate from "@/api/vp/activationPlan/importCampaignsFromTemplate";
import * as apiSetBudget from "@/api/vp/activationPlan/setBudget";
import * as apiGetBudgets from "@/api/vp/activationPlan/getBudgets";
import * as apiGetBudget from "@/api/vp/activationPlan/getBudget";
import * as apiGetCampaigns from "@/api/vp/activationPlan/getCampaigns";
import * as apiGetHQCampaigns from "@/api/vp/activationPlan/getHQCampaigns";
import * as apiGetEvents from "@/api/vp/activationPlan/getEvents";
import * as apiGetEventsByDate from "@/api/vp/activationPlan/getEventsByDate";
import * as apiGetChangeLog from "@/api/vp/activationPlan/getChangeLog";
import * as apiAddCampaign from "@/api/vp/activationPlan/addCampaign";
import * as apiUpdateCampaign from "@/api/vp/activationPlan/updateCampaign";
import * as apiDeleteCampaign from "@/api/vp/activationPlan/deleteCampaign";
import * as apiGetComments from "@/api/vp/activationPlan/getComments";
import * as apiAddComment from "@/api/vp/activationPlan/addComment";
import * as apiUpdateComment from "@/api/vp/activationPlan/updateComment";
import * as apiAddEvent from "@/api/vp/activationPlan/addEvent";
import * as apiDeleteEvent from "@/api/vp/activationPlan/deleteEvent";
import * as apiUpdateEvent from "@/api/vp/activationPlan/updateEvent";
import { _ } from "ag-grid-community";
//import _ from "lodash";

export default {
  namespaced: true,
  state: () => ({
    loading: false,
    events: [],
    comments: [],
    campaigns: [],
    hqCampaigns: [],
    budgets: [],
    changeLog: [],
  }),
  mutations: {
    gotEvents(state, events) {
      state.events = events;
    },
    isLoading(state, loading) {
      state.loading = loading;
    },
    gotComments(state, comments) {
      state.comments = comments;
    },
    gotCampaigns(state, campaigns) {
      state.campaigns = campaigns;
    },
    gotHQCampaigns(state, campaigns) {
      state.hqCampaigns = campaigns;
    },
    gotBudgets(state, receivedBudgets) {
      state.budgets = receivedBudgets;
    },
    gotChangeLog(state, changeLog) {
      state.changeLog = changeLog;
    },
  },
  actions: {
    async importEventsFromTemplate(
      { commit, dispatch },
      { templateId, venueId, year }
    ) {
      console.log("Importing events from template", templateId);
      const result = await apiImportEventsFromTemplate.post(
        templateId,
        venueId,
        year
      );

      if (result) {
        await dispatch("getEvents", venueId);
      }

      return result;
    },

    async importCommentsFromTemplate(
      { commit, dispatch },
      { templateId, venueId, year }
    ) {
      console.log("Importing comments from template", templateId);
      const result = await apiImportCommentsFromTemplate.post(
        templateId,
        venueId,
        year
      );

      if (result) {
        await dispatch("getComments", venueId);
      }

      return result;
    },

    async importCampaignsFromTemplate(
      { commit, dispatch },
      { templateId, venueId, year }
    ) {
      console.log("Importing campaigns from template", templateId);
      const result = await apiImportCampaignsFromTemplate.post(
        templateId,
        venueId,
        year
      );

      if (result) {
        await dispatch("getCampaigns", venueId);
      }

      return result;
    },

    async getComments({ commit }, venueId) {
      const result = await apiGetComments.get(venueId);

      if (result) {
        commit("gotComments", result);
      }
    },

    async getBudget({ commit }, { venueId, year, month }) {
      const result = await apiGetBudget.get(venueId, year, month);

      if (result) {
        commit("gotBudgets", result);
      }
    },

    async getBudgets({ commit }, venueId) {
      const result = await apiGetBudgets.get(venueId);

      if (result) {
        commit("gotBudgets", result);
      }
    },

    /// Will ALSO return all HQ campaigns. Gets all the campaigns for a specific venueId, also if the campaign is a HQ created one
    async getCampaigns({ commit }, venueId) {

      const result = await apiGetCampaigns.get(venueId);

      if (result) {
        commit("gotCampaigns", result);
      }
    },

    /// Will ONLY return HQ campaigns
    async getHQCampaigns({ commit }) {
      const result = await apiGetHQCampaigns.get();

      if (result) {
        commit("gotHQCampaigns", result);
      }
    },

    async addCampaign({ commit, dispatch }, { campaign, venueId }) {
      const result = await apiAddCampaign.post(campaign);
      await dispatch("getCampaigns", venueId);
      if (campaign.isHQ) await dispatch("getHQCampaigns");
      return result;
    },

    async updateCampaign({ commit, dispatch }, { campaign, venueId }) {
      const result = await apiUpdateCampaign.put(campaign);
      await dispatch("getCampaigns", venueId);
      if (campaign.isHQ) await dispatch("getHQCampaigns");
      return result;
    },

    async deleteCampaign({ commit, dispatch }, { campaignId, venueId, refreshHQ }) {
      const result = await apiDeleteCampaign.del(campaignId);
      await dispatch("getCampaigns", venueId);
      if (refreshHQ) await dispatch("getHQCampaigns");
      return result;
    },

    async addComment({ commit, dispatch }, { comment, venueId }) {
      const result = await apiAddComment.post(comment);

      await dispatch("getComments", venueId); // Consider not re-fetching events

      return result;
    },

    async updateComment({ commit, dispatch }, { comment, venueId }) {
      const result = await apiUpdateComment.put(comment);

      await dispatch("getComments", venueId); // Consider not re-fetching events

      return result;
    },

    async getEvents({ commit }, venueId) {
      const result = await apiGetEvents.get(venueId);

      if (result) {
        commit("gotEvents", result);
      }
    },

    async getEventsByDate({ commit }, dateAndVenueQuery) {
      const result = await apiGetEventsByDate.get(dateAndVenueQuery.date, dateAndVenueQuery.venueId);

      if (result) {
        commit("gotEvents", result);
      }
    },

    async addEvent({ commit, dispatch }, event) {
      commit("isLoading", true);

      const result = await apiAddEvent.post(event);

      await dispatch("getEvents", event.venueId); // Consider not re-fetching events

      commit("isLoading", false);

      return result;
    },

    async setBudget({ commit, dispatch }, budget) {
      commit("isLoading", true);
      const result = await apiSetBudget.post(budget);

      await dispatch("getBudgets", budget.venueId);

      commit("isLoading", false);

      return result;
    },

    async updateEvent({ commit, dispatch }, event) {
      commit("isLoading", true);

      const result = await apiUpdateEvent.put(event);

      await dispatch("getEvents", event.venueId); // Consider not re-fetching events

      commit("isLoading", false);

      return result;
    },

    async deleteEvent({ commit, dispatch }, { eventId, venueId }) {
      commit("isLoading", true);

      await apiDeleteEvent.del(eventId);

      await dispatch("getEvents", venueId);

      commit("isLoading", false);
    },
    async getChangeLog({ commit }) {
      const result = await apiGetChangeLog.get();

      if (result) {
        commit("gotChangeLog", result);
      }
    }
  },
  getters: {
    events: state => {
      return state.events;
    },
    event: state => id => {
      return state.events.filter(e => e.activationPlanEventId === id)[0];
    },
    budget: state => (year, month) => {
      return state.budgets.filter(e => e.year === year && e.month == month)[0];
    },
    comment: state => (year, month) => {
      return state.comments.filter(e => e.year === year && e.month == month)[0];
    },
    campaigns: state => (year, month) => {
      return state.campaigns.filter(e => e.year === year && e.month == month);
    },
    hqCampaigns: state => () => {
      return state.hqCampaigns;
    },
    changeLog: state => {
      return state.changeLog;
    }
  }
};
